import type { Category } from "../types";
import type { HomeTrendingMonarchCategoriesBlock } from "../types";

function mapCustomCategories(
  trendingCategories: HomeTrendingMonarchCategoriesBlock | undefined,
) {
  return trendingCategories?.items
    ?.map((item) => {
      if (!item.category) {
        return null;
      }
      const subcategories = item.category?.subcategories ?? [];
      return {
        ...item.category,
        productType: item.category.productType ?? "",
        categoryLabel: item.category.name,
        categoryKey: item.category.categoryKey,
        additionalProductTypes: item.category.additionalProductTypes,
        subcategories: subcategories.map((s) => ({
          subcategoryLabel: s.name,
          customQuery: s.customQuery,
        })),
      };
    })
    .filter(Boolean);
}

export default function mergeCategories(
  categories: Category[],
  trendingCategories: HomeTrendingMonarchCategoriesBlock | undefined,
): Category[] {
  if (
    !trendingCategories ||
    !trendingCategories.items ||
    trendingCategories.items.length === 0
  ) {
    return categories;
  }

  const mappedCustomCategories = mapCustomCategories(trendingCategories) ?? [];

  const monarchCategories = mappedCustomCategories as unknown as Category[];
  // Prevent duplicate categories, monarch categories always override cms categories
  const uniqueCategories = categories.filter((category) => {
    return !monarchCategories.some(
      (c) => c.categoryKey.toLowerCase() === category.categoryKey.toLowerCase(),
    );
  });

  if (trendingCategories.replaceContent) {
    return monarchCategories;
  }

  if (trendingCategories.appendToEnd) {
    return [...uniqueCategories, ...monarchCategories];
  }

  return [...monarchCategories, ...uniqueCategories];
}
